import { render } from "./prescriptionUsage.vue?vue&type=template&id=e3fc9366&scoped=true"
import script from "./prescriptionUsage.vue?vue&type=script&lang=js"
export * from "./prescriptionUsage.vue?vue&type=script&lang=js"

import "./prescriptionUsage.vue?vue&type=style&index=0&id=e3fc9366&lang=scss&scoped=true"

import exportComponent from "D:\\workFolder\\payment-H5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3fc9366"]])

export default __exports__